import styled from 'styled-components';
import {
  IEnumBucketFieldsFragment,
  IRangeBucketFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import { isNotNil } from '../../../utils/types';
import * as BuilderInfoUI from '../BuilderInfoUI';
import React from 'react';
import BuilderInfoLabelList from '../components/BuilderInfoLabelList';

const TextWrapper = styled(BuilderInfoUI.InfoLabel)`
  flex: 0 0 auto;
  min-width: 10px;
  margin-top: 4px;
  margin-right: 0;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
  overflow: visible;
  align-items: flex-start;
`;

const TextTitle = styled(BuilderInfoUI.InfoLabel)`
  flex: 0 0 auto;
  margin-top: 4px;
  margin-right: 0;
  margin-left: 8px;
`;

const StyledBucket = styled(BuilderInfoUI.BorderedInfo)`
  min-width: 60px;
  max-width: 200px;
  margin-right: 0;
`;

export const RangeBucketDefRows = ({
  rangeBuckets,
}: {
  rangeBuckets: IRangeBucketFieldsFragment[];
}) => {
  const rangeBucketsToRender = rangeBuckets.filter(
    (bucket) =>
      isNotNil(bucket.min) &&
      isNotNil(bucket.max) &&
      bucket.min >= 0 &&
      bucket.max >= 0,
  );

  return (
    <>
      {rangeBucketsToRender.map((bucket, index) => (
        <Row key={'range-bucket-info-' + index}>
          <TextWrapper>{`${index + 1}. `}</TextWrapper>
          <StyledBucket>{bucket.min}</StyledBucket>
          <TextWrapper>{` to `}</TextWrapper>
          <StyledBucket>{bucket.max}</StyledBucket>
          {bucket.name && <TextTitle>{bucket.name}</TextTitle>}
        </Row>
      ))}
    </>
  );
};

export const EnumBucketDefRows = ({
  enumBuckets,
}: {
  enumBuckets: IEnumBucketFieldsFragment[];
}) => (
  <>
    {enumBuckets
      .filter((bucket) => bucket.values.length > 0)
      .map((bucket, index) => {
        return (
          <Row key={'enum-bucket-info-' + index}>
            <TextWrapper>{`${index + 1}. `}</TextWrapper>
            <BuilderInfoLabelList
              minWidth={120}
              items={bucket.values.map((value) => value.name)}
            />
            {bucket.name && bucket.isCustomName && (
              <TextTitle>{bucket.name}</TextTitle>
            )}
          </Row>
        );
      })}
  </>
);
